export enum ValidationTypes {
  /** Any */
  IsOptional = 'isOptional',
  UniqueFlag = 'isUnique',
  IsGrouped = 'isGrouped', // Meaning that this field has a parent field that only if a particular format being selected - this field will appear
  IsGroupParent = 'isGroupParent',

  /** Strings */
  IsString = 'isString',
  MaxLength = 'maxLength',
  MinLength = 'minLength',
  IsPhoneNumber = 'isPhoneNumber',
  Matches = 'matches',
  IsEmail = 'isEmail',
  IsDate = 'isDate',
  IsTime = 'isTime',
  IsTimelessDate = 'isTimelessDate',

  /** Numbers */
  IsNumber = 'isNumber',
  Min = 'min',
  Max = 'max',
  IsLatitude = 'isLatitude',
  IsLongitude = 'isLongitude',
  IsId = 'isId',

  /** Boolean */
  IsBoolean = 'isBoolean',

  /** Combined */
  IsEnum = 'isEnum',

  /** Object */
  IsObject = 'isObject',
  IsObjectOf = 'isObjectOf',
  IsAddress = 'isAddress',
  IsDateTimeObject = 'IsDateTimeObject',

  /** Array */
  IsArray = 'isArray',
  IsArrayOf = 'isArrayOf',
  IsUniqueArray = 'isUniqueArray',
  ArrayMinSize = 'arrayMinSize',
  ArrayMaxSize = 'arrayMaxSize',
}

export type ValidationMapping = {
  [propertyName: string]: ValidationInfo[];
};

export type ValidationInfo = {
  type: ValidationTypes;
  parameters?: unknown[];
  nested?: ValidationMapping;
  items?: ValidationInfo[];
};

/** On any modification - please ensure enum values are in sync with backend enum */
export enum MappingFieldsAddressTypes {
  PlainAddress = 'Plain Address',
  Coordinates = 'Coordinates',
  Details = 'Details',
}

/** On any modification - please ensure enum values are in sync with backend enum */
export enum MappingFieldsDateTypes {
  FullDateTime = 'Full Date-Time',
  SeparatedDateTime = 'Separated Date-Time',
}
